'use client'

import { GetPaginationSchema, z } from '@repo/sdk/zod'
import { Button, Skeleton } from '@repo/ui/components'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

export const CustomPagination = ({
  onHover,
  ...meta
}: z.infer<ReturnType<typeof GetPaginationSchema>>['meta'] & {
  onHover?: (page?: number) => void
}) => {
  const searchParams = useSearchParams()
  const pageCount = meta.last_page || 0
  const currentPage = Number(searchParams.get('page')) || 1
  const pathname = usePathname()
  const { replace } = useRouter()
  // const perPage = searchParams.get('perPage') || '10'

  const handlePrevPage = () => {
    const params = new URLSearchParams(searchParams)
    if (currentPage > 1) params.set('page', (currentPage - 1).toString())
    replace(`${pathname}?${params.toString()}`)
  }

  const handleNextPage = () => {
    const params = new URLSearchParams(searchParams)
    if (currentPage < pageCount) params.set('page', (currentPage + 1).toString())
    replace(`${pathname}?${params.toString()}`)
  }

  // const handlePageChange = (page: number) => {
  //   const params = new URLSearchParams(searchParams)
  //   params.set('page', page.toString())
  //   replace(`${pathname}?${params.toString()}`)
  // }

  // const handlePerPageChange = (perPage: string) => {
  //   const params = new URLSearchParams(searchParams)
  //   params.set('perPage', perPage)
  //   replace(`${pathname}?${params.toString()}`)
  // }

  return (
    <div className={'flex w-full items-center justify-between gap-2'}>
      <p className={'text-sm text-gray-600'}>
        {meta.from}-{meta.to} of {meta.total}
      </p>
      <div className={'flex items-center gap-2'}>
        <Button
          className={'h-8'}
          disabled={currentPage === 1}
          onClick={handlePrevPage}
          onMouseEnter={() => {
            onHover?.(currentPage - 1)
          }}
          variant="outline"
        >
          Prev
        </Button>
        <Button
          className={'h-8'}
          disabled={currentPage === pageCount || pageCount === 0}
          onClick={handleNextPage}
          onMouseEnter={() => {
            onHover?.(currentPage + 1)
          }}
          variant="outline"
        >
          Next
        </Button>
      </div>
      {/*<Select onValueChange={e => handlePerPageChange(e)} value={perPage}>*/}
      {/*  <SelectTrigger className="w-24">*/}
      {/*    <SelectValue />*/}
      {/*  </SelectTrigger>*/}
      {/*  <SelectContent>*/}
      {/*    {[10, 20, 50, 100].map(size => (*/}
      {/*      <SelectItem key={size} value={size.toString()}>*/}
      {/*        {size} rows*/}
      {/*      </SelectItem>*/}
      {/*    ))}*/}
      {/*  </SelectContent>*/}
      {/*</Select>*/}
    </div>
  )
}

export const CustomPaginationFallback = () => {
  return (
    <div className={'flex w-full items-center justify-between gap-2'}>
      <div className={'flex items-center gap-2 text-sm text-gray-600'}>
        <Skeleton className={'size-4'} />
        <p>-</p>
        <Skeleton className={'size-6'} />
        <p>of</p>
        <Skeleton className={'size-6'} />
      </div>
      <div className={'flex items-center gap-2'}>
        <Button className={'h-8'} disabled variant="outline">
          Prev
        </Button>
        <Button className={'h-8'} disabled variant="outline">
          Next
        </Button>
      </div>
      {/*<Select onValueChange={e => handlePerPageChange(e)} value={perPage}>*/}
      {/*  <SelectTrigger className="w-24">*/}
      {/*    <SelectValue />*/}
      {/*  </SelectTrigger>*/}
      {/*  <SelectContent>*/}
      {/*    {[10, 20, 50, 100].map(size => (*/}
      {/*      <SelectItem key={size} value={size.toString()}>*/}
      {/*        {size} rows*/}
      {/*      </SelectItem>*/}
      {/*    ))}*/}
      {/*  </SelectContent>*/}
      {/*</Select>*/}
    </div>
  )
}
